import Piscineiro from './imageWork/Front-piscineiro.png';
import Tecnico from './imageWork/itamarMaquinas.png';
import SpellBook from './imageWork/spellBook.png';
import CalculadoraImc from './imageWork/CalculadoraIMC.png';
import TodoList from './imageWork/TodoListReact.png';
import JogoNSecreto from './imageWork/jogo-n-secreto.png';
import Decodificador from './imageWork/decodificador.png';
import ConversorMoedas from './imageWork/conversorMoedas.png';
import PortalTech from './imageWork/img-portaltech.jpg';
import Tedeschi from './imageWork/tedeschiveiculos.png';
import DivineShine from './imageWork/DivineShine.jpeg';
import PagesGlow from './imageWork/PagesGlow.png';

const ImagesWork = {
    "front-piscinas": Piscineiro, 
    "front-tecnico": Tecnico,
    "front-dndSpellApp": SpellBook,
    "front-imcCalculator": CalculadoraImc,
    "front-taskList": TodoList,
    "front-numeroSecreto": JogoNSecreto,
    "front-decodificadorTexto": Decodificador,
    "front-tedeschi": Tedeschi,
    "front-divineShine": DivineShine,
    "front-pagesGlow": PagesGlow,
    "fullstack-conversorPhp": ConversorMoedas,
    "fullstack-sistemaChamados": PortalTech,
};

export default ImagesWork